import { render, staticRenderFns } from "./pollWithImages.vue?vue&type=template&id=14d880f0"
import script from "./pollWithImages.vue?vue&type=script&lang=js"
export * from "./pollWithImages.vue?vue&type=script&lang=js"
import style0 from "./pollWithImages.vue?vue&type=style&index=0&id=14d880f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports